import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

export default function Sidebar({setOpacity = ()=>{}, links = [], currentContent = 'loreal', setCurrentContent = ()=>{}}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 960);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(()=>{
    setIsOpen(true);
  }, [window.innerWidth]);

  useEffect(()=>{
    console.log(currentContent);
  },[currentContent])

  return (
    <div style={{zIndex: 1000, backgroundColor: '#303030'}} className="d-flex">
      {/* Bouton pour ouvrir le menu sur mobile */}
      <button
        style={{zIndex: 500}}
        className="btn btn-dark position-fixed top-0 start-0 m-3 d-lg-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      <motion.aside
        initial={{ x: "-100%" }}
        animate={{ x: isOpen ? 0 : "-100%" }}
        transition={{ duration: 0.3 }}
        className={`position-fixed top-0 start-0 vh-100 bg-dark text-white p-4 d-flex flex-column align-items-center justify-content-center ${
          (isOpen || !isMobile) ? 'd-flex' : 'd-none'
        }`}
        style={{ width: isMobile ? '100%' : '20%' }} // Largeur responsive
      >
        <img style={{width: '80%', marginBottom: '3em', borderRadius: '50%'}} src="./assets/pp.jpeg"/>
        <h2 className="fs-3 fw-bold mb-5">Julien Jacobs</h2>
        <nav>
          <ul className="list-unstyled text-center text-lg-start">
            {links.map((link, index) => (
              <li key={index} className="mb-3">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    if(link.href === currentContent) return;
                    if(isMobile) setIsOpen(false);
                    setOpacity(0);
                    setTimeout(()=>{
                        setCurrentContent(link.href);
                        setOpacity(1);
                    },150)
                  }}
                  className="text-white fs-5 p-2 d-block rounded bg-secondary bg-opacity-50 hover-bg-opacity-100"
                  style={{ cursor: 'pointer', backgroundColor: (link.href === currentContent) ? 'black' : '', textDecoration: (currentContent === link.href) ? 'underline' : 'none' }}
                >
                  {link.name}
                </div>
              </li>
            ))}
          </ul>
        </nav>
      </motion.aside>
    </div>
  );
}
